export const CLOUDINARY_BASE_URL = "https://res.cloudinary.com/drxijtp8g/image/upload/";
